import React from "react";
import { useGlobalPresence } from "newui/features/Company/hooks/useGlobalPresence";
import {
	SelectWithLabel,
	BaseSelectWithLabelProps,
	SelectOption,
} from "../InputWithLabel/SelectWithLabel";
import { useFormikFieldState } from "./useFormikField";

interface GlobalPresenceSelectProps
	extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
	selectedIds?: number[];
}

export const GlobalPresenceSelect: React.FC<GlobalPresenceSelectProps> = ({
	label = "Global Presence",
	placeholder = "Select regions",
	selectedIds,
	value: valueProp,
	hasError: hasErrorProp,
	errorText: errorTextProp,
	onChange: onChangeProp,
	name,
	...rest
}) => {
	const { values, isLoading } = useGlobalPresence();
	const formik = useFormikFieldState(name);

	const options: SelectOption[] = values.map((gp) => ({
		label: gp.name,
		value: gp.id,
	}));

	const resolvedValue = selectedIds
		? isLoading
			? undefined
			: selectedIds
				.map((id) => options.find((o) => o.value === id))
				.filter(Boolean) as SelectOption[]
		: valueProp;

	const handleChange = (selected: SelectOption | SelectOption[] | null) => {
		formik.markTouched();
		onChangeProp?.(selected);
	};

	return (
		<SelectWithLabel
			options={options}
			isLoading={isLoading}
			isMulti
			label={label}
			placeholder={placeholder}
			value={resolvedValue}
			name={name}
			hasError={hasErrorProp || formik.hasError}
			errorText={errorTextProp || formik.errorText}
			onChange={handleChange}
			{...rest}
		/>
	);
};
